import { render, staticRenderFns } from "./Devises.vue?vue&type=template&id=2d1f4e7d"
import script from "./Devises.vue?vue&type=script&lang=js"
export * from "./Devises.vue?vue&type=script&lang=js"
import style0 from "./Devises.vue?vue&type=style&index=0&id=2d1f4e7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports